const messages = {
  title: "Vouchers",
  short_description:
    "You can find there your vouchers list. You can share with your client. Vouchers is one-time usage.",
  table: {
    headers: {
      voucher: "Voucher codes",
      company: "Company",
      street: "Street",
      postcode: "Postcode",
      location: "Location",
      solved_at: "Date",
      points: "Number of points via the code",
    },
  },
  exchange: {
    title: "Enter your code to get points",
    pointsLabel: "Enter the code here:",
    result: "Number of points:",
  },
};

export default {
  messages,
};
